import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { shared } from '../../assets/images'
import { RecaptchaNotice } from '../RecaptchaNotice'
import {
  Page,
  Column,
  Logo,
  Card,
  LegalLink,
  Copyright,
} from './styles'

// Marco común del login y del código: fondo de marca, logo y tarjeta centrada.
function AuthLayout({ children }) {
  return (
    <Page component="main">
      <CssBaseline />
      <Column>
        <Logo src={shared.trakku} alt="Trakku" />
        <Card>{children}</Card>
        <RecaptchaNotice />
        <Copyright>
          {`© ${new Date().getFullYear()} `}
          <LegalLink href="https://www.autecomobility.com/" target="_blank" rel="noopener noreferrer">
            Trakku by Auteco Mobility
          </LegalLink>
        </Copyright>
      </Column>
    </Page>
  )
}

export { AuthLayout }
